<template>
  <!--
  <div :id="uniqueId" :class="classnames" @click="handleClick">
    <div :class="`${ns}__container`">
      <div :class="`${ns}__bar-container`">
        <div :class="`${ns}__bar`">
          <div :class="`${ns}__title-container`">
            <div :class="`${ns}__title`">Homepage</div>
          </div>

          <div :class="`${ns}__range-container`">
            <div :class="`${ns}__range`">Dec 26th, 2019 - Jan 1st, 2020</div>
          </div>

          <div :class="`${ns}__icon-container`">
            <div :class="`${ns}__icon`">To Top</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->
</template>

<script>
  import ScrollMagic from 'scrollmagic'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'status-bar'
  // let myScroll = null

  function initializeScrollMagic (component) {
    // let _$pdpTriggerElement = null
    let _$plpTriggerElement = null
    let _$triggerElement = null

    setTimeout(function () {
      // _$pdpTriggerElement = document.querySelector('.tab-content')
      _$plpTriggerElement = document.querySelector('.products')
      _$triggerElement = _$plpTriggerElement

      // console.log('_$pdpTriggerElement')
      // console.log(_$pdpTriggerElement)
      // console.log('')
      // console.log('_$plpTriggerElement')
      // console.log(_$plpTriggerElement)

      const controller = new ScrollMagic.Controller()

      const scene = new ScrollMagic.Scene({
        triggerElement: _$triggerElement,
        triggerHook: 0,
        reverse: true
      })

      // scene.addIndicators()
      scene.on('leave enter', function (event) {
        const eventType = event.type

        if (eventType === 'enter') {
          component.setState('isActive', true)
        } else if (eventType === 'leave') {
          component.setState('isActive', false)
        }
      })
      scene.addTo(controller)
    }, 1000)
  }

  export default {
    name: 'StatusBar',
    components: {},
    mixins: [ bem ],
    props: {},
    data: function () {
      return {
        isActive: false
      }
    },
    created: function () {
      // this.onCreated()
    },
    mounted: function () {
      // this.onMounted()
    },
    methods: {
      classnameModifiers: function () {
        const isActive = this.isActive && 'is-active'

        return [
          isActive
        ]
      },
      handleClick: function () {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      onCreated: function () {
        this.setNamespace(namespace)
      },
      onMounted: function () {
        initializeScrollMagic(this)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/StatusBar.vue